import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import useCheckABFlag from "@hooks/useCheckABFlag";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { URL_SELL_TRADE_LANDING } from "@/pages/module-sell-trade/SellTradeContext";
var SearchCategories = function SearchCategories() {
  var isABTestEnabled = useCheckABFlag("AB_SELL_MY_CAR_V3");
  var sellTradeUrl = isABTestEnabled ? URL_SELL_TRADE_LANDING_v2 : URL_SELL_TRADE_LANDING;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var data = [{
    img: CDN_LINK + "/assets/images/usedCars.svg",
    title: t("السيارات المستعملة", {
      ns: "web_home"
    }),
    description: t("مضمونة و مكفولة", {
      ns: "web_home"
    }),
    link: createUrl("/filters", {
      condition_id: "0"
    }, {
      referral_location: "home",
      browse_variant: "main_area",
      variant_value: "cta_used"
    })
  }, {
    img: CDN_LINK + "/assets/images/newCars.svg",
    title: t("السيارات الجديدة", {
      ns: "web_home"
    }),
    description: t("ضمان الوكالة", {
      ns: "web_home"
    }),
    link: createUrl("/filters", {
      condition_id: "1"
    }, {
      referral_location: "home",
      browse_variant: "main_area",
      variant_value: "cta_new"
    })
  }, {
    img: CDN_LINK + "/assets/images/sellTous.svg",
    title: t("بيعنا سيارتك", {
      ns: "web_home"
    }),
    description: t("نشتريها بافضل سعر", {
      ns: "web_home"
    }),
    link: createUrl(sellTradeUrl),
    event: function event() {
      return trackEvents("sell_car_started", {
        referral_location: "homepage_card",
        platform: getPlatformInfo(),
        version: isABTestEnabled && "3"
      });
    }
  }, {
    img: CDN_LINK + "/assets/images/financeCar.svg",
    title: t("تمويل السيارات", {
      ns: "web_home"
    }),
    description: t("خيارات تمويل متعددة", {
      ns: "web_home"
    }),
    link: createUrl("/financing"),
    event: function event() {
      return trackEvents("browse_cars", {
        referral_location: "home",
        browse_variant: "main_area",
        variant_value: "cta_finance",
        category_path: null
      });
    },
    customSize: "55px"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[9px] flex-wrap justify-between mt-6 md:gap-[15px]"
  }, data.map(function (item, i) {
    var _item$customSize, _item$customSize2;
    return /*#__PURE__*/React.createElement("a", {
      href: item === null || item === void 0 ? void 0 : item.link,
      onClick: item === null || item === void 0 ? void 0 : item.event,
      key: i + "SearchCategories",
      className: "w-[calc(50%-5px)] md:w-[calc(100%/4-15px)] flex flex-col gap-[12px] justify-center items-center rounded-[4px] bg-white shadow-[0_0_12px_0_rgba(0,0,0,0.10)] p-3",
      id: "search-categories_search-categories-".concat(i)
    }, /*#__PURE__*/React.createElement("img", {
      src: item === null || item === void 0 ? void 0 : item.img,
      className: item !== null && item !== void 0 && item.customSize ? "relative left-[13px] top-[7px]" : undefined,
      width: (_item$customSize = item === null || item === void 0 ? void 0 : item.customSize) !== null && _item$customSize !== void 0 ? _item$customSize : "40px",
      height: (_item$customSize2 = item === null || item === void 0 ? void 0 : item.customSize) !== null && _item$customSize2 !== void 0 ? _item$customSize2 : "40px",
      alt: item === null || item === void 0 ? void 0 : item.title
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#484848] text-base font-bold leading-[24px] min-h-[24px]"
    }, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/React.createElement("span", {
      className: "text-[#484848] text-sm font-medium leading-[24px] min-h-[24px]"
    }, item === null || item === void 0 ? void 0 : item.description));
  }));
};
export default SearchCategories;